import { render, staticRenderFns } from "./file-status.vue?vue&type=template&id=a3896ef6&scoped=true"
import script from "./file-status.vue?vue&type=script&lang=js"
export * from "./file-status.vue?vue&type=script&lang=js"
import style0 from "./file-status.vue?vue&type=style&index=0&id=a3896ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3896ef6",
  null
  
)

export default component.exports